import React from 'react';
import PropTypes from 'prop-types';

function DoorCharts({ configurationChart, handingChart, configAlt, handingAlt }) {
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h6>Configuration Chart</h6>
        <img
          src={configurationChart}
          alt={configAlt}
          style={{ maxWidth: '100%', marginBottom: 8 }}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <h6>Handing Chart</h6>
        <img
          src={handingChart}
          alt={handingAlt}
          style={{ maxWidth: '100%', marginBottom: 8 }}
        />
      </div>
    </div>
  );
}

DoorCharts.propTypes = {
  configurationChart: PropTypes.string.isRequired,
  handingChart: PropTypes.string.isRequired,
  configAlt: PropTypes.string.isRequired,
  handingAlt: PropTypes.string.isRequired,
};

export default DoorCharts;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/charts/DoorCharts.jsx